"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_i18next_1 = require("react-i18next");
var PostViewSelectOptions_1 = require("../../../../constants/PostViewSelectOptions");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ConstructorBankSelectOption = function (_a) {
    var mortgage = _a.mortgage, setSelectedBank = _a.setSelectedBank, selectedBank = _a.selectedBank;
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState([]), bankOptions = _b[0], setBankOptions = _b[1];
    var isExclusive = react_1.useMemo(function () {
        return (mortgage &&
            mortgage.some(function (item) { return item.is_exclusive === 'is_available'; }));
    }, [mortgage]);
    react_1.useLayoutEffect(function () {
        PostViewSelectOptions_1.DefaultBank.text = t(PostViewSelectOptions_1.DefaultBank.name);
        if (mortgage && mortgage[0].name) {
            var filteredBanks = mortgage.map(function (item, index) { return (__assign(__assign({}, item), { key: index, value: item.name, text: t(item.name), image: {
                    avatar: true,
                    src: PostViewSelectOptions_1.BankSelectOptionValues.find(function (options) { return options.text === item.name; }).image.src,
                } })); });
            !isExclusive
                ? setBankOptions(__spreadArray(__spreadArray([], filteredBanks), [PostViewSelectOptions_1.DefaultBank]))
                : setBankOptions(filteredBanks);
        }
        else {
            setBankOptions([PostViewSelectOptions_1.DefaultBank]);
        }
    }, [mortgage]);
    react_1.useEffect(function () {
        if (isExclusive) {
            setSelectedBank(bankOptions.filter(function (item) { return item.is_exclusive === 'is_available'; })[0]);
        }
        else {
            setSelectedBank(bankOptions[0]);
        }
    }, [isExclusive, bankOptions]);
    var handleChange = function (event, data) {
        var filteredBank = bankOptions.find(function (item) { return item.name === data.value; });
        setSelectedBank(filteredBank);
    };
    return selectedBank ? (react_1.default.createElement(semantic_ui_react_1.Dropdown, { fluid: true, selection: true, className: styles_module_scss_1.default.dropdown, options: bankOptions, value: selectedBank.name, onChange: handleChange })) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = ConstructorBankSelectOption;
